var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5918 3.30944C1.5918 2.21802 2.47657 1.33325 3.56799 1.33325H17.187C18.2785 1.33325 19.1632 2.21802 19.1632 3.30944V9.04589C19.0417 9.33516 19.0417 9.66493 19.1632 9.9542V15.6904C19.1632 16.7818 18.2785 17.6666 17.187 17.6666H3.56799C2.47657 17.6666 1.5918 16.7818 1.5918 15.6904V3.30944ZM20.1632 10.8798V15.6904C20.1632 17.3341 18.8307 18.6666 17.187 18.6666H3.56799C1.92428 18.6666 0.591797 17.3341 0.591797 15.6904V3.30944C0.591797 1.66574 1.92428 0.333252 3.56799 0.333252H17.187C18.8307 0.333252 20.1632 1.66574 20.1632 3.30944V8.12029L26.4137 3.65567C27.1859 3.10412 28.2585 3.65609 28.2585 4.60503V14.3951C28.2585 15.344 27.1859 15.896 26.4137 15.3444L20.1632 10.8798ZM20.1632 9.6509L26.9949 14.5307C27.1052 14.6095 27.2585 14.5306 27.2585 14.3951V4.60503C27.2585 4.46947 27.1052 4.39061 26.9949 4.46941L20.1632 9.34919V9.6509Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.310e35a59d8d309bea55117340f2f181.svg";
export { ForwardRef as ReactComponent };